import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ImageCacheService {
  private imageCache: Map<string, string>;

  constructor() {
    // Khởi tạo imageCache từ localStorage nếu có, nếu không tạo một Map mới
    const cachedData = localStorage.getItem('imageCache');
    this.imageCache = cachedData ? new Map(JSON.parse(cachedData)) : new Map();
  }

  getImage(url: string): string | undefined {
    return this.imageCache.get(url);
  }

  setImage(url: string, data: string): void {
    this.imageCache.set(url, data);
    // Lưu trữ imageCache vào localStorage sau mỗi lần setImage được gọi
    localStorage.setItem('imageCache', JSON.stringify(Array.from(this.imageCache.entries())));
  }

  isInCache(name: string): boolean {
    return this.imageCache.has(name);
  }

  deleteCache(): void {
    this.imageCache.clear();
    // Xóa cả dữ liệu trong localStorage khi deleteCache được gọi
    localStorage.removeItem('imageCache');
  }
}
